import { render, staticRenderFns } from "./CardTransactionsTable.vue?vue&type=template&id=24ee0022&scoped=true&"
import script from "./CardTransactionsTable.vue?vue&type=script&lang=js&"
export * from "./CardTransactionsTable.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=24ee0022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ee0022",
  null
  
)

export default component.exports